import type { AiClientInterface, MessageHubSuggestionsParams } from './aiClient.types';
import BaseClient from '../BaseClient';

export default class GroupAiClient extends BaseClient implements AiClientInterface {
    constructor(private teamId: number, private groupId: string) {
        super();
    }

    messageHubSuggestions(params: MessageHubSuggestionsParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/ai/message`;
        return this.makeCoreApiRequest(url, 'post', params);
    }
}
